import React from 'react';
import classnames from 'classnames';

import DashSVG from '../svg/icons/dash.svg';

const DashIcon = ({ className }) => (
  <DashSVG
    className={classnames('mx-auto w-5 text-mid-gray opacity-50', className)}
  />
);

const PricingFeatureText = ({ text }) =>
  text ? text : <DashIcon className="text-mid-gray opacity-50" />;

export default PricingFeatureText;
